import { useState } from "react";
import { useNavigate } from "react-router-dom";

const useChatNavigation = () => {
  const [lan, setLan] = useState(localStorage.getItem("laung") ?? "en");
  const navigate = useNavigate();

  const letChat = (item) => {
    const data = {
      post_id: item?.id,
      user_id: item?.user_id,
    };
    navigate(`/${lan}/account/chats/`, { state: { userdetails: data } });
  };

  return { letChat };
};

export default useChatNavigation;
